"use strict";

exports.__esModule = true;
exports.default = void 0;
var _consts = require("../../utils/layout/consts");
const getSpacing = theme => ({
  [_consts.SPACINGS.NONE]: "",
  [_consts.SPACINGS.XXXSMALL]: theme.orbit.spaceXXXSmall,
  [_consts.SPACINGS.XXSMALL]: theme.orbit.spaceXXSmall,
  [_consts.SPACINGS.XSMALL]: theme.orbit.spaceXSmall,
  [_consts.SPACINGS.SMALL]: theme.orbit.spaceSmall,
  [_consts.SPACINGS.MEDIUM]: theme.orbit.spaceMedium,
  [_consts.SPACINGS.LARGE]: theme.orbit.spaceLarge,
  [_consts.SPACINGS.XLARGE]: theme.orbit.spaceXLarge,
  [_consts.SPACINGS.XXLARGE]: theme.orbit.spaceXXLarge,
  [_consts.SPACINGS.XXXLARGE]: theme.orbit.spaceXXXLarge
});
var _default = getSpacing;
exports.default = _default;